import React, { Fragment } from "react";
import NavBar from "./layout/NavBar";
import { Outlet } from "react-router-dom";
import Footer from "./layout/Footer";

const App = () => {
  return (
    <Fragment>
      <NavBar />
      <main>
        <Outlet />
      </main>
      <Footer />
    </Fragment>
  );
};

export default App;
